module.exports = __webpack_public_path__ + "static/img/dialog_2.85bb0de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/guide/dialog_2.png
// module id = IZth
// module chunks = 4